import { View } from "ui/atoms/view";
import { Button, ButtonText } from "ui/gluestack/button";

interface Props {
  okTitle?: string;
  cancelTitle?: string;
  disabled?: boolean;
  onClose: () => void;
  onSave: () => void;
}
export function FormButtons({
  disabled,
  okTitle,
  cancelTitle,
  onClose,
  onSave,
}: Props) {
  return (
    <View className="mt-4 justify-end flex-row gap-4">
      <Button
        disabled={disabled}
        onPress={onClose}
        variant="outline"
        className="min-w-24"
      >
        <ButtonText>{cancelTitle || "Cancel"}</ButtonText>
      </Button>
      <Button disabled={disabled} onPress={onSave} className="min-w-24">
        <ButtonText>{okTitle || "Save"}</ButtonText>
      </Button>
    </View>
  );
}
